export const rubrosHistoricos = [
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2025.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2025.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2025.zip"
            },

                        {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2025.zip"
            }


        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2024.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2024.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2024.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2024.zip"
            }



        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2023.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2023.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2023.zip"
            },
             {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2023.zip"
            } 
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2022.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2022.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2022.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2022.zip"
            }
        ]
    },

    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2021.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2021.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2021.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2021.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2020.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2020.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2020.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2020.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1T2019.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2T2019.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3T2019.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4T2019.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../zip/1Trimestre.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../zip/2Trimestre.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../zip/3Trimestre.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../zip/4Trimestre.zip"
            }
        ]
    },


    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.plataformadetransparencia.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "../zip/21rubros.zip"
            }
        ]
    }
]